"use strict";

var _regeneratorRuntime = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/slicedToArray");

require("regenerator-runtime/runtime.js");

var _asyncToGenerator = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("source-map-support/register");

var _error = require("../error");

var _lodash = require("lodash");

function search(buildList) {
  return {
    find: function find(criteria) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var matcher, allItems;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                matcher = function matcher(item) {
                  return Object.entries(criteria).every(function (_ref) {
                    var _ref2 = _slicedToArray(_ref, 2),
                        key = _ref2[0],
                        value = _ref2[1];

                    return (0, _lodash.get)(item, key) == value;
                  });
                };

                _context.next = 3;
                return buildList();

              case 3:
                allItems = _context.sent;
                return _context.abrupt("return", allItems.filter(matcher));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    findOne: function findOne(criteria) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var matches;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this.find(criteria);

              case 2:
                matches = _context2.sent;

                if (!(matches.length === 0)) {
                  _context2.next = 5;
                  break;
                }

                throw new _error.SearchError('No items found for search criteria');

              case 5:
                return _context2.abrupt("return", matches[0]);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  };
}

var _default = search;
exports.default = _default;